import {css} from '@emotion/react'

export const root = css`
    display: flex;
    flex-direction: column;
    width: 271px;
    min-width: 271px;
`;

export const logout = css` 
    background: indianred;
    font-size:16px;
       &:hover {
            background: #c14845;
       }   
`;

export const spanGroup = css` 
   padding-left: 24px;
   display: inline-grid; 
`;

export const spanEmail = css` 
   font-size: 11px;
   margin-top:5px;
   word-break: break-all;
   color: rgba(255, 255, 255, 0.65);
`;


export const navigationRoot = css`
    background-color: #434864;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const column = css`
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    height: 205px;
    flex: 1;
    align-items: center;
    justify-content: center;
`;
export const row = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
    justify-content: center;
`;